import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { SECONDARY_COLOR } from '../../../color-constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ButtonWrapper = styled.div`
  display: flex;
  cursor: pointer;
  margin-right: 50px;
  margin-bottom: 10px;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  min-height: 16px;
  max-height: 16px;
  width: 16px;
  min-width: 16px;
  max-width: 16px;
  border: 1px solid #9FA0A4;
  border-radius: 50%;

  ${props => props.selected && `
    background-color: ${SECONDARY_COLOR};
    border: 1px solid ${SECONDARY_COLOR};
  `}
`;

const SelectedMask = styled.div`
  height: 8px;
  min-height: 8px;
  max-height: 8px;
  width: 8px;
  min-width: 8px;
  max-width: 8px;
  border-radius: 50%;
  background-color: white;
`;

const Label = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #0F0F0F;
  margin-left: 10px;
`;

const Field = styled.textarea`
  margin-top: 10px;
  font-family: inherit !important;
  padding: 10px;
`;

class SurveyRadio extends React.Component {

  static propTypes = {
    question: PropTypes.object,
    answer: PropTypes.object,
    getLabel: PropTypes.func,
    onChange: PropTypes.func,
  }

  render = () => {
    let answerValue = null;
    if(this.props.answer && this.props.answer.value){
      answerValue = this.props.answer.value;
    }
    let answerTitle = null;
    if(this.props.answer && this.props.answer.title){
      answerTitle = this.props.answer.title;
    }
    let answerOpenField = null;
    if(this.props.answer && this.props.answer.openField){
      answerOpenField = this.props.answer.openField;
    }
    return (
      <Container>
        <ButtonsWrapper>
          {this.props.question.answers.map((answer, idx) => <ButtonWrapper key={idx} onClick={() => {
            if (answer.key !== answerValue) {
              this.props.onChange({
                title: answer.title,
                value: answer.key
              });
            }
          }}>
            <Button selected={answerValue === answer.key}>
              {answerValue === answer.key && <SelectedMask></SelectedMask>}
            </Button>
            <Label>{this.props.getLabel(answer.key)}</Label>
          </ButtonWrapper>)}
        </ButtonsWrapper>
        {this.props.question.showAdditionalTextField && (this.props.question.showTextFieldOnValue === answerValue) && <Field
          value={answerOpenField || ''}
          onChange={(event) => {
            this.props.onChange({
              title: answerTitle,
              value: answerValue,
              openField: event.target.value
            });
          }}
          placeholder={this.props.getLabel('embedded_survey.provide_more_detail')}
          rows="5">
        </Field>}
      </Container>
    );
  }
}

export default SurveyRadio;
